var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { combineEpics } from "redux-observable";
import { loadingControlTowerExperience, loadedControlTowerExperience } from "./GlobalConfigActions.js";
import { of } from "rxjs";
import CurrentUserDetailsActionConstants from "../userDetails/CurrentUserDetailsActionsConstants.js";
import MdsDataplaneResource from "../resources/MdsDataplaneResource.js";
import MasterDataConstants from "../constants/FeatureDataConstants.js";
import { getExperimentationGroupIdFromPath } from "../utils/ManagementGroup/ManagementGroup.utils.js";
import Logger from "@ane/core/lib/services/logging/Logger";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { RestResult } from "@ane/core/lib/services/RestServiceBase";
const loadControlTowerExperienceArgs = {
  filterOnType: CurrentUserDetailsActionConstants.LOADED_USER_AFFINITY,
  loadResource: (payload) => __async(void 0, null, function* () {
    Logger.setUserManagementGroupAndWorkspaceId(payload.managementGroup, payload.workspaceId);
    const workspaceId = payload.workspaceId;
    let mgPath = payload.managementGroup;
    if (!mgPath) {
      mgPath = yield MdsDataplaneResource.getExperimentationGroupRootPath(workspaceId);
    }
    if (!!mgPath) {
      const experimentationGroup = !!mgPath ? getExperimentationGroupIdFromPath(payload.workspaceId, mgPath) : "";
      return MdsDataplaneResource.getConfigWithTypeV2({
        workspaceId: payload.workspaceId,
        experimentationGroup,
        section: MasterDataConstants.controlTowerExperienceSection
      });
    }
    return Promise.resolve(RestResult.fromResult({}));
  }),
  loadingAction: loadingControlTowerExperience,
  loadedAction: (successData) => of(loadedControlTowerExperience(successData))
};
const loadControlTowerExperienceEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadControlTowerExperienceArgs);
const GlobalConfigEpic = combineEpics(loadControlTowerExperienceEpic);
export {
  GlobalConfigEpic as default,
  loadControlTowerExperienceEpic
};
//# sourceMappingURL=GlobalConfigEpic.js.map
